var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DeckGLComponent',{attrs:{"layers":_vm.layers,"viewState":_vm.viewState,"controller":_vm.controller},on:{"click":_vm.handleClick,"view-state-change":_vm.updateViewState}},[_c('div',{ref:"deckmap",attrs:{"id":"deckmap"}})])}
var staticRenderFns = []

export { render, staticRenderFns }